import axios from 'axios'
import {
 ASSIGN_PROCESSES_TO_SUPERVISOR_REQUEST,
 ASSIGN_PROCESSES_TO_SUPERVISOR_SUCCESS,
 ASSIGN_PROCESSES_TO_SUPERVISOR_FAIL,
 ASSIGN_PROCESSES_TO_SUPERVISOR_RESET,
 GET_SUPERVISOR_PROCESS_ASSIGNMENTS_REQUEST,
 GET_SUPERVISOR_PROCESS_ASSIGNMENTS_SUCCESS,
 GET_SUPERVISOR_PROCESS_ASSIGNMENTS_FAIL,
 GET_SUPERVISOR_PROCESS_ASSIGNMENTS_RESET,
 UPDATE_SUPERVISOR_PROCESS_ASSIGNMENT_REQUEST,
 UPDATE_SUPERVISOR_PROCESS_ASSIGNMENT_SUCCESS,
 UPDATE_SUPERVISOR_PROCESS_ASSIGNMENT_FAIL,
 UPDATE_SUPERVISOR_PROCESS_ASSIGNMENT_RESET,
 DELETE_SUPERVISOR_PROCESS_ASSIGNMENT_REQUEST,
 DELETE_SUPERVISOR_PROCESS_ASSIGNMENT_SUCCESS,
 DELETE_SUPERVISOR_PROCESS_ASSIGNMENT_FAIL,
 DELETE_SUPERVISOR_PROCESS_ASSIGNMENT_RESET,
} from '../constants/assignProcessConstants';
import { logout } from './userActions';

const baseUrl = process.env.REACT_APP_API_URL;

export const assignProcessesToSupervisor = (supervisorId, processIds) => async (dispatch, getState) => {
 try {
   dispatch({
     type: ASSIGN_PROCESSES_TO_SUPERVISOR_REQUEST,
   });

   const {
     userLogin: { userInfo },
   } = getState();

   const config = {
     headers: {
       'Content-Type': 'application/json',
       Authorization: `Bearer ${userInfo.token}`,
     },
   };

   const { data } = await axios.post(
     `${baseUrl}/assignProcess/assign`,
     { supervisorId, processIds },
     config
   );

   dispatch({
     type: ASSIGN_PROCESSES_TO_SUPERVISOR_SUCCESS,
     payload: data,
   });
 } catch (error) {
   if (error.response?.status === 401) {
     dispatch(logout());
     return;
   }
   dispatch({
     type: ASSIGN_PROCESSES_TO_SUPERVISOR_FAIL,
     payload:
       error.response && error.response.data.message
         ? error.response.data.message
         : error.message,
   });
 }
};

export const getSupervisorProcessAssignments = (queryParams) => async (dispatch, getState) => {
 try {
   dispatch({
     type: GET_SUPERVISOR_PROCESS_ASSIGNMENTS_REQUEST,
   });

   const {
     userLogin: { userInfo },
   } = getState();

   const config = {
     headers: {
       'Content-Type': 'application/json',
       Authorization: `Bearer ${userInfo.token}`,
     },
   };

   const { data } = await axios.get(
     `${baseUrl}/assignProcess${queryParams ? `?${queryParams}` : ''}`,
     config
   );

   dispatch({
     type: GET_SUPERVISOR_PROCESS_ASSIGNMENTS_SUCCESS,
     payload: data,
   });
 } catch (error) {
   if (error.response?.status === 401) {
     dispatch(logout());
     return;
   }
   dispatch({
     type: GET_SUPERVISOR_PROCESS_ASSIGNMENTS_FAIL,
     payload:
       error.response && error.response.data.message
         ? error.response.data.message
         : error.message,
   });
 }
};

export const updateSupervisorProcessAssignment = (id, processIds) => async (dispatch, getState) => {
 try {
   dispatch({
     type: UPDATE_SUPERVISOR_PROCESS_ASSIGNMENT_REQUEST,
   });

   const {
     userLogin: { userInfo },
   } = getState();

   const config = {
     headers: {
       'Content-Type': 'application/json',
       Authorization: `Bearer ${userInfo.token}`,
     },
   };

   const { data } = await axios.put(
     `${baseUrl}/assignProcess/${id}`,
     { processIds },
     config
   );

   dispatch({
     type: UPDATE_SUPERVISOR_PROCESS_ASSIGNMENT_SUCCESS,
     payload: data,
   });
 } catch (error) {
   if (error.response?.status === 401) {
     dispatch(logout());
     return;
   }
   dispatch({
     type: UPDATE_SUPERVISOR_PROCESS_ASSIGNMENT_FAIL,
     payload:
       error.response && error.response.data.message
         ? error.response.data.message
         : error.message,
   });
 }
};

export const deleteSupervisorProcessAssignment = (id) => async (dispatch, getState) => {
 try {
   dispatch({
     type: DELETE_SUPERVISOR_PROCESS_ASSIGNMENT_REQUEST,
   });

   const {
     userLogin: { userInfo },
   } = getState();

   const config = {
     headers: {
       'Content-Type': 'application/json',
       Authorization: `Bearer ${userInfo.token}`,
     },
   };

   const { data } = await axios.delete(
     `${baseUrl}/assignProcess/${id}`,
     config
   );

   dispatch({
     type: DELETE_SUPERVISOR_PROCESS_ASSIGNMENT_SUCCESS,
     payload: data,
   });
 } catch (error) {
   if (error.response?.status === 401) {
     dispatch(logout());
     return;
   }
   dispatch({
     type: DELETE_SUPERVISOR_PROCESS_ASSIGNMENT_FAIL,
     payload:
       error.response && error.response.data.message
         ? error.response.data.message
         : error.message,
   });
 }
};